import React from 'react'
import './ImageStyleSheet.css';

function RogerSeven() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/roger7.jpeg" className='img-view'/>
        </div>
    )
}

export default RogerSeven
